module.exports = __webpack_public_path__ + "static/chen_wang-a8161d0d1ede6a448fbd58ef803e7821.png";